// This file was generated by figma/utils.mjs
export const ARCADE_ICONS_NAMES = {
  ACCOUNTVERIFIED: 'AccountVerified',
  ADD: 'Add',
  ALERTFILL: 'AlertFill',
  ALERTREPORTEDFILL: 'AlertReportedFill',
  ATTACH: 'Attach',
  AVATAR: 'Avatar',
  BACKCENTERED: 'BackCentered', // manually added
  BANKACCOUNT: 'BankAccount',
  BITCOINLIGHTNING: 'BitcoinLightning',
  BORROW: 'Borrow',
  BUSINESS: 'Business',
  CAMERAFILL: 'CameraFill',
  CARDADD: 'CardAdd',
  CARDBASIC: 'CardBasic',
  CARDINACTIVE: 'CardInactive',
  CARDSUPPORT: 'CardSupport',
  CATEGORYAUTO: 'CategoryAuto',
  CATEGORYHEALTHMEDICAL: 'CategoryHealthMedical',
  CATEGORYMOVING: 'CategoryMoving',
  CATEGORYRENT: 'CategoryRent',
  CATEGORYSHOPPING: 'CategoryShopping',
  CHECK: 'Check',
  CHECKFILL: 'CheckFill',
  CLEAR: 'Clear',
  CLOSE: 'Close',
  COLLAPSE: 'Collapse',
  COMMCHAT: 'CommChat',
  COMMEMAIL: 'CommEmail',
  COMMPHONEFILL: 'CommPhoneFill',
  COMMSMSFILL: 'CommSmsFill',
  CONTROL: 'Control',
  COPY: 'Copy',
  CURRENCYUSD: 'CurrencyUsd',
  DATA: 'Data',
  DATE: 'Date',
  DELIVERY: 'Delivery',
  DEPOSITBARCODE: 'DepositBarcode', // manually added
  DEPOSITCHECK: 'DepositCheck',
  DEVICEMOBILE: 'DeviceMobile',
  DISCOUNTPERCENTAGE: 'DiscountPercentage',
  DISCOUNTTAG: 'DiscountTag',
  DISCOUNTTAGFILL: 'DiscountTagFill',
  DOCUMENT: 'Document',
  DOWNLOAD: 'Download',
  EDIT: 'Edit',
  EXPAND: 'Expand',
  FAILEDFILL: 'FailedFill', // manually added
  FAST: 'Fast',
  FAVORITE: 'Favorite',
  FAVORITEFILL: 'FavoriteFill',
  GIFTCARD: 'Giftcard',
  HSACARD: 'HsaCard',
  HYPERLINK: 'Hyperlink',
  IDEA: 'Idea',
  INFORMATIONOUTLINE: 'InformationOutline',
  INTERNATIONAL: 'International',
  LIKE: 'Like',
  LIMITS: 'Limits',
  LINKOUT: 'LinkOut',
  LOCATION: 'Location',
  LOCATIONDUO: 'LocationDuo',
  LOCATIONFILL: 'LocationFill',
  LOCKLOCKED: 'LockLocked',
  LOGOAFTERPAY: 'LogoAfterpay',
  LOGOUT: 'LogOut',
  MENUAFTERPAY: 'MenuAfterpay',
  MORE: 'More',
  NOCREDITCHECK: 'NoCreditCheck',
  NOTIFICATIONS: 'Notifications',
  PAYINFOUR: 'PayInFour',
  PAYLATER: 'PayLater',
  PRINTER: 'Printer',
  PUSH: 'Push',
  RECURRINGAUTOMATIC: 'RecurringAutomatic',
  REFRESH: 'Refresh',
  REFUNDED: 'Refunded',
  SAVINGS: 'Savings',
  SEARCH: 'Search',
  SEND: 'Send',
  SENSITIVEHIDDEN: 'SensitiveHidden',
  SENSITIVEVISIBLE: 'SensitiveVisible',
  SHARE: 'Share',
  SHOPPINGCART: 'ShoppingCart',
  SWAPCURRENCY: 'SwapCurrency',
  TICKERDOWN: 'TickerDown',
  TICKERLEFT: 'TickerLeft', // manually added
  TICKERRIGHT: 'TickerRight', // manually added
  TICKERUP: 'TickerUp',
  TIME: 'Time',
  TRANSFERWIRE: 'TransferWire',
  ZERO: 'Zero',
} as const
